import { render, staticRenderFns } from "./Clocks.vue?vue&type=template&id=70040476&scoped=true&lang=html&"
import script from "./Clocks.vue?vue&type=script&lang=js&"
export * from "./Clocks.vue?vue&type=script&lang=js&"
import style0 from "./Clocks.vue?vue&type=style&index=0&id=70040476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70040476",
  null
  
)

export default component.exports